import { FunctionComponent, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "src/components/generic";
import { RadioGroupWithRegister } from "src/components/inputs";
import { quizzes, sendgrid } from "src/utils";

interface ICreditQuiz101Props {
    name: string;
    email?: string;
    confirmSubmit: (value: boolean) => void;
}

const CreditQuiz101: FunctionComponent<ICreditQuiz101Props> = ({ name, email, confirmSubmit }) => {
    const [errors, setErrors] = useState({
        q1: '',
        q2: '',
        q3: '',
        q4: '',
        q5: '',
        q6: '',
        q7: '',
        q8: '',
        q9: '',
        q10: '',
    });
    const {
        register,
        handleSubmit,
        watch,
    } = useForm({
        defaultValues: {
            q1: '',
            q2: '',
            q3: '',
            q4: '',
            q5: '',
            q6: '',
            q7: '',
            q8: '',
            q9: '',
            q10: '',
        }
    });
    const watched = watch();
    console.log({watched})

    const submit = async (values: any) => {
        try {
            const result = quizzes.creditBasics101.checkAnswers(values);
        
            console.log({result, values});
            setErrors(result.incorrect)
            if(result.pass) {
                await sendgrid.sendStudentSubmittedQuiz(name, email || "", 'Credit Basics 101')
                confirmSubmit(result.pass)
            }
        } catch(error) {
            console.log({error});
        }
    }

    const Errors: FunctionComponent = () => {
        if(!errors) return <></>;
        const keys = Object.keys(errors);

        return (
            <div>
                {
                    //@ts-ignore
                    keys.map((key: string) => errors[key]?.message && <p>{errors[key]?.message}</p>)
                }
            </div>
        )
    }

    return (
        <div className="text-center flex flex-col justify-center items-center py-8">
            <form className="w-[70%] border border-primary rounded-md py-16 px-12">
                <div className="mb-20">
                    <h4 className="mb-4 text-2xl font-medium">Credit Quiz Basics (101)</h4>
                    <p className="text-md">Complete the questions and score perfectly to receive ClientVitals Certificate of Completion.</p>
                </div>
                <Errors />

                <form>
                    {
                        quizzes.creditBasics101.questions.map((question, index) => (
                            <RadioGroupWithRegister
                                question={`${index+1}.) ${question.question}`}
                                options={question.answerOptions.map((option, index) => {
                                    const letter = index === 0 ? 'A' :
                                                    index === 1 ? 'B' :
                                                    index === 2 ? 'C' : 'D'
                                    return {
                                        id: letter,
                                        label: `${letter}) ${option}`
                                    }
                                })}
                                name={`q${index+1}`}
                                register={register}
                                //@ts-ignore
                                error={errors[`q${index+1}`]}
                                answersStyles="flex-col"
                                questionStyles="text-xl text-left my-6"
                            />
                        ))
                    }

                    <Button
                        text="Submit"
                        onClick={handleSubmit(submit)}
                        styles="mt-10"
                    />
                </form>
            </form>
        </div>
    );
}

export default CreditQuiz101;